const COUNTRY_API_URL = "https://restcountries.com/v3.1/all?fields=name,cca2,idd,flag";

export const DEFAULT_COUNTRY = {
  name: "India",
  code: "IN",
  flag: "IN",
  dialCode: "+91",
  text: "IN +91",
  value: "+91"
};

let countryListPromise;

export const normalizeDialCode = (root, suffixes) => {
  if (!root) {
    return "";
  }

  const suffix = Array.isArray(suffixes) && suffixes.length > 0 ? suffixes[0] : "";
  return `${root}${suffix}`;
};

const mapCountry = (country) => {
  const code = country?.cca2 || "";
  const name = country?.name?.common || code;
  const flag = country?.flag || "";
  const dialCode = normalizeDialCode(country?.idd?.root, country?.idd?.suffixes);

  return {
    code,
    name,
    flag,
    dialCode,
    text: `${flag} ${dialCode}`.trim(),
    value: dialCode
  };
};

export const getCountryList = async () => {
  if (!countryListPromise) {
    countryListPromise = fetch(COUNTRY_API_URL)
      .then((response) => response.json())
      .then((data) => {
        const countries = (Array.isArray(data) ? data : [])
          .map(mapCountry)
          .filter((country) => country.code && country.dialCode)
          .sort((first, second) => first.name.localeCompare(second.name));

        return countries.length > 0 ? countries : [DEFAULT_COUNTRY];
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
        countryListPromise = undefined;
        return [DEFAULT_COUNTRY];
      });
  }

  return countryListPromise;
};

export const getCountryCodeOptions = async () => {
  const countries = await getCountryList();
  return countries.map(({ text, value }) => ({ text, value }));
};

export const detectCountryCode = () =>
  new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve(DEFAULT_COUNTRY.code);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
          );
          const payload = await response.json();
          resolve(payload?.address?.country_code?.toUpperCase() || DEFAULT_COUNTRY.code);
        } catch (error) {
          console.error("Country detection failed", error);
          resolve(DEFAULT_COUNTRY.code);
        }
      },
      () => resolve(DEFAULT_COUNTRY.code),
      {
        timeout: 7000,
        maximumAge: 1800000,
        enableHighAccuracy: false
      }
    );
  });